import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Communication } from '../../../../graphql/comms.datatypes';
import { gqlCommunication } from '../getCommunication.api';

interface UpdateCommunicationInput {
  data: {
    id: number
    ident?: string
    communication_type?: number
    title?: string
    body?: string
    receiver?: number
    log_code?: string
    active?: boolean
    mandatory?: boolean

    triggerValues?: {
      create?: any,
      update?: any,
      delete?: any,
    }
  }
}

interface UpdateCommunicationData {
  __typename?: string,
  updateCommunication: Communication
}

export const UPDATE_COMMUNICATION_MUTATION = gql`
    mutation updateCommunication($data: UpdateCommunicationInput!) {
        updateCommunication(data: $data) {
            ${gqlCommunication}
        }
    }
`;

export const updateCommunication = () => useMutation<UpdateCommunicationData, UpdateCommunicationInput>(
  UPDATE_COMMUNICATION_MUTATION,
  {
  }
);

export default updateCommunication;